module.exports = __webpack_public_path__ + "media/my_images/detail/hour-2928287b97408b741ac61e460ce1b3c8.svg";